export default __webpack_public_path__ + "static/media/annex13.ac8d755c.png";